import * as types from 'constants/ActionTypes';
import { DEALERS_API_URL } from 'constants/ApiConstants';
import { APPOINTMENT_TASK_TYPES } from 'constants/AppointmentConstants';

/**
 * @param {{ dealerId: string, language: string }} param
 * @param {Object} [meta={}]
 * @returns {import('modules/dealers/types').DepositPreviewAction}
 */
export const depositPreview = ({ dealerId, language }, meta = {}) => ({
  type: types.DEPOSIT_PREVIEW,
  payload: {
    request: {
      method: 'GET',
      url: `${DEALERS_API_URL}/${dealerId}/config/keyDeposit/link`,
      params: {
        language,
        type: APPOINTMENT_TASK_TYPES.KEY_DEPOSIT,
      },
    },
  },
  meta,
});

/**
 * @param {string} link
 * @param {Object} [meta={}]
 * @returns {import('modules/dealers/types').DepositPreviewSuccessAction}
 */
export const depositPreviewSuccess = (link, meta = {}) => ({
  type: types.DEPOSIT_PREVIEW_SUCCESS,
  payload: link,
  meta,
});

/**
 * @param {string} message
 * @param {Object} [meta={}]
 * @returns {import('modules/dealers/types').DepositPreviewFailureAction}
 */
export const depositPreviewFailure = (message, meta = {}) => ({
  type: types.DEPOSIT_PREVIEW_FAILURE,
  payload: message,
  error: true,
  meta,
});

/**
 * @param {{ dealerId: string, language: string }} param0
 * @param {Object} [meta={}]
 * @returns {import('modules/dealers/types').PickupPreviewAction}
 */
export const pickupPreview = ({ dealerId, language }, meta = {}) => ({
  type: types.PICKUP_PREVIEW,
  payload: {
    request: {
      method: 'GET',
      url: `${DEALERS_API_URL}/${dealerId}/config/keyDeposit/link`,
      params: {
        language,
        type: APPOINTMENT_TASK_TYPES.KEY_RETRIEVE,
      },
    },
  },
  meta,
});

/**
 * @param {string} link
 * @param {Object} [meta={}]
 * @returns {import('modules/dealers/types').PickupPreviewSuccessAction}
 */
export const pickupPreviewSuccess = (link, meta = {}) => ({
  type: types.PICKUP_PREVIEW_SUCCESS,
  payload: link,
  meta,
});

/**
 * @param {string} message
 * @param {Object} [meta={}]
 * @returns {import('modules/dealers/types').PickupPreviewFailureAction}
 */
export const pickupPreviewFailure = (message, meta = {}) => ({
  type: types.PICKUP_PREVIEW_FAILURE,
  payload: message,
  error: true,
  meta,
});
